module.exports = __webpack_public_path__ + "static/img/pic5.8350d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/home/pic5.png
// module id = OAk8
// module chunks = 20